import { api } from './api';

export interface ProdutoSacola {
  linha: number;
  idCodigoBarras: string;
  idProduto: string | null;
  codigoBarras: string;
  referencia: string;
  nomeProduto: string;
  idEntrada: string | null;
}

export interface Sacola {
  id: number;
  quantidade: number;
  data: string;
  nomeUsuario: string;
  produtos: ProdutoSacola[];
}

export const sacolaService = {
  buscaCodigoBarras: async (codigoBarras: string): Promise<any> => {
    const response = await api.get(`/api/Sacola/GetInformacaoPorCodigoDeBarras?codigoBarra=${codigoBarras}`);
    return response.data;
  },

  liberarCodigoBarras: async (codigoBarras: string): Promise<any> => {
    const response = await api.get(`/api/Sacola/LiberarCodigoDeBarras?codigoBarra=${codigoBarras}`);
    return response.data;
  },

  salvar: async (produtos: ProdutoSacola[]): Promise<any> => {
    const response = await api.post('/api/Sacola/Salvar', produtos);
    return response.data;
  },

  getAll: async (): Promise<Sacola[]> => {
    const response = await api.get<Sacola[]>('/api/Sacola/GetAllSacolas');
    return response.data;
  },

  getById: async (id: number): Promise<Sacola> => {
    const response = await api.get<Sacola>(`/api/Sacola/GetSacolaById?id=${id}`);
    return response.data;
  },

  getByIdProdutosSemEntrada: async (ids: number[]): Promise<any> => {
    const params = ids.map((id) => `ids=${id}`).join('&');
    const response = await api.get(`/api/Sacola/GetSacolaByIdProdutosSemEntrada?${params}`);
    return response.data;
  },
};
